var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "#5F5F5F",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 58.5651C41.9616 58.5651 41.4233 58.3667 40.9983 57.9417L22.525 39.4684C19.5216 36.4651 19.5216 31.5351 22.525 28.5317L40.9983 10.0584C41.82 9.23672 43.18 9.23672 44.0016 10.0584C44.8233 10.8801 44.8233 12.2401 44.0016 13.0617L25.5283 31.5351C24.1683 32.8951 24.1683 35.1051 25.5283 36.4651L44.0016 54.9384C44.8233 55.7601 44.8233 57.1201 44.0016 57.9417C43.5766 58.3384 43.0383 58.5651 42.5 58.5651Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.fc3cf8cd77335a08e8d8d221457b27ae.svg";
export { ForwardRef as ReactComponent };